// Override de especialidad SOLO para demos comerciales (pedido explícito
// del usuario 2026-09-01) — nunca escribe en Medplum ni en el backend, es
// puro estado del navegador (localStorage, por conveniencia entre recargas
// durante una demo en vivo). Gateado en useEspecialidadDelPracticante.ts a
// una única cuenta (dra.demo@logiacare.com): en cualquier otra cuenta este
// override simplemente no se consulta, la especialidad sigue siendo la real
// resuelta desde el PractitionerRole de Medplum.
const STORAGE_KEY = 'hce-demo-especialidad-override';

type Listener = () => void;
const listeners = new Set<Listener>();

function leerStorage(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

let valorActual: string | null = leerStorage();

export function getEspecialidadDemoOverride(): string | null {
  return valorActual;
}

export function setEspecialidadDemoOverride(codigo: string | null): void {
  valorActual = codigo;
  try {
    if (codigo) window.localStorage.setItem(STORAGE_KEY, codigo);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage no disponible (modo privado, etc.) — el override sigue
    // funcionando en memoria para el resto de la sesión del navegador.
  }
  listeners.forEach((l) => l());
}

export function subscribeEspecialidadDemoOverride(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
